import { Flex, Text, Button, Image } from '@chakra-ui/react';
import { AuthenticatedComponent } from '../../auth/keycloak';
import { ProductDef } from '../../service/inventory';
import StreamGoldIcon from '../../assets/store/StreamGold.svg';
import React from 'react';

interface GameProductProps {
    product: ProductDef;
    image: string;
    isPurchasing: boolean;
    purchaseClick: React.MouseEventHandler<HTMLButtonElement> | undefined;
}

export const GameProduct: AuthenticatedComponent<GameProductProps> = ({
    product,
    image,
    isPurchasing,
    purchaseClick,
}) => {
    return (
        <Flex className="game-product">
            <Image src={image} />
            <Text className={'game-product-name'}>{product.product_name}</Text>
            <Button className="currency-button" isLoading={isPurchasing} onClick={purchaseClick}>
                <Image src={StreamGoldIcon} />
                {product.cost[0].quantity} - Buy
            </Button>
        </Flex>
    );
};
